import { Box, Text, Tooltip } from "@chakra-ui/react"
import { summarizeNames } from "lib/membership"

// At most this many names are listed in the tooltip (a group can have hundreds of locations)
const TOOLTIP_NAMES = 30

// The names in a table cell that opens a list (a drawer) when clicked. Narrow on purpose: it never
// makes the column wider. It uses the three lines a row has, one name per line (a long name is cut
// with "..."): up to three names, or two names and "+N more" on the third line. The mouse resting
// on it shows the names in full.
// - names: the names to show, sorted by the caller
// - none:  what the tooltip says when there is nothing to show
// Used as the `trigger` of an ActionDrawer.
export default function LinkNames({ names, none }) {
  const { shown, more } = summarizeNames(names)
  const full = names.length > TOOLTIP_NAMES
    ? `${names.slice(0, TOOLTIP_NAMES).join(", ")} +${names.length - TOOLTIP_NAMES} more`
    : names.join(", ")

  return (
    <Tooltip label={names.length > 0 ? full : none}>
      <Box as="button" type="button" textAlign="left" w="100%" maxW="240px" cursor="pointer"
        color={names.length > 0 ? "green.600" : "gray.500"} _hover={{ textDecoration: "underline" }}>
        {names.length === 0 && <Text fontSize="sm" lineHeight="19px">None</Text>}
        {shown.map((name, i) => <Text key={i} fontSize="sm" lineHeight="19px" isTruncated>{name}</Text>)}
        {more > 0 && <Text fontSize="sm" lineHeight="19px" fontWeight="semibold">+{more} more</Text>}
      </Box>
    </Tooltip>
  )
}
